import {DetailsList, IconButton, PrimaryButton, SearchBox, SelectionMode, SharedColors} from "@fluentui/react";
import * as React from "react";
import {useContext, useEffect, useState} from "react";
import AppContent from "../Surfaces/AppContent";
import AuthContext from "../Services/AuthContext";
import AddAgreementProtocol from "../Panel/AgreementProtocol/AddAgreementProtocol";
import EditAgreementProtocol from "../Panel/AgreementProtocol/EditAgreementProtocol";
import {Link, useOutletContext} from "react-router-dom";
import {whitespaceMatcher} from "../Utilities/WhitespaceMatcher";
import {MoneyField} from "../Utilities/MoneyField";
import { netGrossColumn, useNetGross } from "../Utilities/NetGrossField";

function Cost(props) {
    const [user] = useContext(AuthContext);
    const netGross = useNetGross();
    const [costs, setCosts] = useState([]);
    const [refresh, setRefresh] = useState(0);
    const [filtered, setFiltered] = useState([]);
    const [filter, setFilter] = useState('');

    useEffect(() => {
        const abortController = new AbortController();
        async function fetchData() {
            await fetch("/api/agreement/protocol", {
                method: 'GET',
                signal: abortController.signal,
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(data => { setCosts(data) })
                .catch(err => { console.log(err) })
        }
        fetchData();
        return () => abortController.abort();
    }, [refresh, user.token]);
    const [editCost, setEditCost] = useState(false);
    const [addCost, setAddCost] = useState(false);
    const actions = useOutletContext();
    useEffect(() => {
        actions([
            {
                key: 'addCost',
                text: 'Dodaj Koszt',
                iconProps: { iconName: 'Add' },
                onClick: () => setAddCost(true)
            }
        ]);
        return actions;
    }, []);

    const costLink = (item) => {
        let color = SharedColors.greenCyan10;
        if (item.distributed - item.gross_value > 0) {
            color = SharedColors.red10;
        } else if (item.distributed - item.gross_value < 0) {
            color = SharedColors.cyanBlue10;
        }
        return (<Link to={`/cost/${item.id}`}><PrimaryButton styles={{root: {backgroundColor: color, borderColor: color},
            rootHovered: {backgroundColor: color, borderColor: color}}} text={item.number} /></Link>);

    }

    const [columns, setColumns] = useState([]);
    useEffect(() => {
        setColumns([
            {
                key: 'invoice_number',
                name: 'Faktura',
                ariaLabel: 'Numer Faktury',
                fieldName: 'invoice_number',
                minWidth: 210,
                maxWidth: 210,
                isRowHeader: true,
                isResizable: false,
                onRender: costLink
            },
            {
                key: 'from',
                name: 'Kontrahent',
                ariaLabel: 'Nazwa Kontrahenta',
                fieldName: 'from',
                isResizable: true,
            },
            {
                key: 'note',
                name: 'Notatka',
                ariaLabel: 'Notatka',
                fieldName: 'note',
                minWidth: 400,
                isResizable: true,
            },
            {
                key: 'venture',
                name: 'Kontrakty',
                ariaLabel: 'Kontrakty',
                fieldName: 'venture',
                minWidth: 200,
                isResizable: true,
            },
            {
                key: 'date',
                name: 'Data',
                ariaLabel: 'Data Wystawienia',
                fieldName: 'date',
                isResizable: true,
                isSorted: true
            },
            {
                ...netGrossColumn()
            },
            {
                key: 'edit',
                name: 'Akcje',
                ariaLabel: 'Akcje',
                fieldName: 'edit',
                minWidth: 70,
                maxWidth: 70,
                onRender: (item) => (<span>
                <IconButton iconProps={ {iconName: 'edit' }} title='Edytuj' onClick={() => setEditCost(item)}/>
                <IconButton iconProps={ {iconName: 'delete' }} title='Usuń' onClick={() => _deleteCost(item)}/>
            </span>)
            }
        ]);
    }, [netGross]);
    const _deleteCost = (item) => {
        fetch(`/api/agreement/protocol/${item.id}`, {
            method: 'DELETE',
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(json => { setRefresh(refresh + 1) })
            .catch(err => { console.log(err) })
    }

    useEffect(() => {
        setFiltered(costs.filter(item => whitespaceMatcher(filter, [item.invoice_number, item.venture, item.note, item.projects, item.from].join(' '))));
    }, [filter, costs]);

    return (
        <AppContent title={'Koszty'}>
            <SearchBox placeholder="Wyszukaj" value={filter} onChange={(e, value) => setFilter(value)} />
            <DetailsList items={filtered} columns={columns} selectionMode={SelectionMode.none}/>
            <AddAgreementProtocol add={addCost} onSuccess={() => setRefresh(refresh + 1)} dismissPanel={() => setAddCost(false)} />
            <EditAgreementProtocol add={editCost} onSuccess={() => setRefresh(refresh + 1)} dismissPanel={() => setEditCost(false)} />
        </AppContent>
    );
}

export default Cost;